import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductForm, {
  ProductFormFields,
} from '../../components/Product/ProductForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

export default function ProductsNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: ProductFormFields) => {
    try {
      await api.post(`organizations/${organization.id}/products`, data);

      navigate('/products');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const [formFields, setFormFields] = useState<ProductFormFields>(
    {} as ProductFormFields
  );

  return (
    <ProductForm
      isLoading={1 + 1 === 1}
      title='Novo'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
